import React from "react";
import ArrowButton from "../utils/button/ArrowButton";
import FinalReadingModal from "../reading/FinalReadingModal";
import LandScapeModal from "../utils/modal/LandScapeModal";
import ErrorModal from "../utils/modal/ErrorModal";
import StoryImage from "../utils/StoryImage";
import StoryContentToggle from "../utils/StoryContentToggle";
import AudioBookSelectionModal from "../audiobook/AudioBookSelectionModal";
import Flipbook from "../flipbook/Flipbook";
import NovelFrame from "../flipbook/NovelFrame";
import { getLocalizedAssetPath } from "../../utils/getLocalizedLogo";

const AudioSharingPC = ({
  bookData,
  story,
  index,
  setIndex,
  showFinalReadingModal,
  setShowFinalReadingModal,
  showErrorModal,
  setShowErrorModal,
  errorMessage,
  bgImage,
  contentText,
  handleButtonClick,
  handleExit,
  audioRef,
  pageName,
  navigate,
  showAudioBookModal,
  setShowAudioBookModal,
  audioBookList,
  handleSelectAudioBook,
  handleDeleteAudioBooks,
  bookID,
  isFlipping,
  setIsFlipping,
  isBookOpened,
  setIsBookOpened,
  showFlipbook,
  setShowFlipbook,
  showTitleOnCover,
  setShowTitleOnCover,
  encryptUrlSafe,
}) => {
  return (
    <>
      {bookData?.style === "graphic_novel" ||
      bookData?.style === "그림 소설" ? (
        <NovelFrame
          isFlipping={isFlipping}
          showLogo={true}
          isOpened={showFlipbook}
        >
          {showFlipbook ? (
            <div className="flipbook-fade-in-wrapper">
              <Flipbook
                index={index}
                story={story}
                setStory={null}
                pageCount={story.length}
                setShowFinalModal={setShowFinalReadingModal}
                setIsFlipping={setIsFlipping}
                handleChangeBackground={null}
                setIndex={setIndex}
                isReadOnly={true}
                title={bookData?.title}
                cover={bookData?.bookcover}
              />
            </div>
          ) : (
            <div
              className={`book-shelf-cover ${isBookOpened ? "opened" : ""}`}
              onClick={() => {
                if (isBookOpened) return;
                setIsBookOpened(true);
                setTimeout(() => {
                  setShowFlipbook(true);
                  setIndex(0);
                }, 600);
              }}
            >
              <div className="result-book-container">
                <div className="result-book">
                  <div className="cover-content">
                    <div className="cover-title-toggle-tabs">
                      <button
                        className={`toggle-tab ${showTitleOnCover ? "active" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowTitleOnCover(true);
                        }}
                      >
                        <img
                          src={
                            showTitleOnCover
                              ? getLocalizedAssetPath(
                                  "/images/makingBranch/title-on.svg",
                                )
                              : getLocalizedAssetPath(
                                  "/images/makingBranch/title-off.svg",
                                )
                          }
                          alt="제목 보기"
                        />
                      </button>
                      <button
                        className={`toggle-tab ${!showTitleOnCover ? "active" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowTitleOnCover(false);
                        }}
                      >
                        <img
                          src={
                            showTitleOnCover
                              ? getLocalizedAssetPath(
                                  "/images/makingBranch/cover-off.svg",
                                )
                              : getLocalizedAssetPath(
                                  "/images/makingBranch/cover-on.svg",
                                )
                          }
                          alt="표지 보기"
                        />
                      </button>
                    </div>
                    <img src={bookData?.bookcover} alt="cover" />
                    <h2
                      className={`novel-title ${!showTitleOnCover ? "hide" : ""}`}
                    >
                      {bookData?.title}
                    </h2>
                  </div>
                </div>
                <figure className="result-book-left">
                  <img
                    src="/images/utils/modal/novelFinalModal/book-left.svg"
                    alt="spine"
                  />
                </figure>
                <figure className="result-book-bottom">
                  <img
                    src="/images/utils/modal/novelFinalModal/book-bottom.svg"
                    alt="pages"
                  />
                </figure>
              </div>
            </div>
          )}
        </NovelFrame>
      ) : (
        <section className="stories-section">
          <img
            src="/images/logo/magic4u-logo.svg"
            alt="로고"
            className="magic-logo"
          />
          {showErrorModal && (
            <ErrorModal
              error_message={errorMessage}
              onClose={() => {
                setShowErrorModal(false);
                navigate("/storyland");
              }}
            />
          )}
          <StoryImage src={bgImage} alt="bg-img" />
          <StoryContentToggle
            showTitleOnCover={showTitleOnCover}
            setShowTitleOnCover={setShowTitleOnCover}
          />
          <div className="story-ui-layer">
            <ArrowButton
              onClick={() => handleButtonClick("left")}
              direction="left"
              className="story-btn prev-btn"
            />
            <ArrowButton
              onClick={() => handleButtonClick("right")}
              direction="right"
              className="story-btn next-btn"
            />
            <div
              className={`story-contents-container ${
                !showTitleOnCover ? "hide" : ""
              }`}
            >
              <ul className="story-contents">
                <li className="origin-text">
                  {contentText}
                  <div className="text-stroke">{contentText}</div>
                </li>
              </ul>
            </div>
            <div className="numbering">{index + 1}</div>
          </div>
        </section>
      )}
      <audio ref={audioRef} playsInline />

      {showFinalReadingModal && (
        <FinalReadingModal
          onBack={() => setIndex(0)}
          pageName={pageName}
          onClose={handleExit}
        />
      )}
      {showAudioBookModal && (
        <AudioBookSelectionModal
          audiobooks={audioBookList}
          onSelect={handleSelectAudioBook}
          onClose={() => {
            setShowAudioBookModal(false);
            window.close();
          }}
          bookID={bookID}
          onReadTextBook={(book_id) => {
            navigate(`/share?book_id=${encryptUrlSafe(bookID)}`, {
              state: {
                pageName,
                bookID: book_id,
              },
            });
          }}
          onDeleteSelected={handleDeleteAudioBooks}
        />
      )}

      <LandScapeModal />
    </>
  );
};

export default AudioSharingPC;
